import { Injectable } from '@angular/core';
import { DataEntityVersionChanges } from '@osos/shared/api';
import { DataEntityVersionChangesPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';
import { FieldFactoryService } from '../../factories';

@Injectable()
export class EntityVersionChangesParserV1Service extends ParserBase<
  DataEntityVersionChanges,
  DataEntityVersionChangesPresenterModel
> {
  constructor(private fieldFactory: FieldFactoryService) {
    super(DataEntityVersionChanges, DataEntityVersionChangesPresenterModel, 1);
  }
  getPresenterModel(
    model: Partial<DataEntityVersionChanges>
  ): DataEntityVersionChangesPresenterModel {
    return {
      changeType: model.changeType,
      isBreaking: model.isBreaking,
      field: model.field
        ? this.fieldFactory.createPresenterModel(model.field)
        : null,
    };
  }

  getDataModel(
    presenter: DataEntityVersionChangesPresenterModel
  ): DataEntityVersionChanges {
    return null;
  }
}
